<template>
  <div class="hd-TopMenu_Item">
    <button
      class="hd-TopMenu_Link hd-TopMenu_MainLink btn btn-reset shadow-none rounded-0"
      type="button"
      @click="toggleShowOverlay"
    >
      <div class="position-relative hd-TopMenu_Icon">
        <i class="icon icon-cart hd-TopMenu_Icon pr-1"></i>
        <span
          v-if="itemsInShoppingCart"
          class="badge badge-pill badge-primary hd-TopMenu_CartCount"
          >{{ itemsInShoppingCart }}</span
        >
      </div>
      <span class="hd-TopMenu_LinkLabel">
        {{ translations.cart }}
      </span>
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ShoppingCartButton",
  props: {
    translations: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getAllLineItems: "shoppingCart/getAllLineItems",
    }),
    itemsInShoppingCart() {
      return this.getAllLineItems.reduce((sum, lineItem) => sum + lineItem.quantity, 0);
    },
  },
  mounted() {
    this.fetchAllLineItems();
  },
  methods: {
    ...mapActions({
      fetchAllLineItems: "shoppingCart/fetchAllLineItems",
      toggleShowOverlay: "shoppingCart/toggleShowOverlay",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.hd-TopMenu_CartCount {
  font-size: $font-size-cart-count-mobile;
  font-variant-numeric: tabular-nums;
  position: absolute !important;
  top: -$spacer / 6 !important;
  right: -$spacer / 6 !important;
}
</style>
